module.exports = "<div class=\"spinner-wrapper\" *ngIf=\"status\">\n  <div>\n    <mat-spinner></mat-spinner>\n  </div>\n</div>\n\n"